import {
  CHECK_CALENDAR_CAN_BE_DELETED,
  CHECK_CALENDAR_CAN_BE_DELETED_FAILED,
  CHECK_CALENDAR_CAN_BE_DELETED_SUCCESS,
  CLONE_CALENDAR,
  CLONE_CALENDAR_FAILED,
  CLONE_CALENDAR_SUCCESS,
  CREATE_BOOKING,
  CREATE_BOOKING_FAILED,
  CREATE_BOOKING_SUCCESS,
  CREATE_BOOKING_CALENDAR,
  CREATE_BOOKING_CALENDAR_FAILED,
  CREATE_BOOKING_CALENDAR_SUCCESS,
  CREATE_SUB_CALENDAR,
  CREATE_SUB_CALENDAR_FAILED,
  CREATE_SUB_CALENDAR_SUCCESS,
  DELETE_CALENDAR,
  DELETE_CALENDAR_FAILED,
  DELETE_CALENDAR_SUCCESS,
  DELETE_SUB_CALENDAR,
  DELETE_SUB_CALENDAR_FAILED,
  DELETE_SUB_CALENDAR_SUCCESS,
  GET_ALL_CALENDARS,
  GET_ALL_CALENDARS_FAILED,
  GET_ALL_CALENDARS_SUCCESS,
  GET_ALL_SUB_CALENDARS,
  GET_ALL_SUB_CALENDARS_FAILED,
  GET_ALL_SUB_CALENDARS_SUCCESS,
  GET_BOOKINGS,
  GET_BOOKINGS_FAILED,
  GET_BOOKINGS_SUCCESS,
  GET_CALENDAR,
  GET_BOOKING_CALENDARS,
  GET_BOOKING_CALENDARS_FAILED,
  GET_BOOKING_CALENDARS_SUCCESS,
  GET_CALENDAR_FAILED,
  GET_CALENDAR_SUCCESS,
  GET_SUB_CALENDAR,
  GET_SUB_CALENDARS,
  GET_SUB_CALENDARS_FAILED,
  GET_SUB_CALENDARS_SUCCESS,
  GET_SUB_CALENDAR_FAILED,
  GET_SUB_CALENDAR_SUCCESS,
  HIDE_CLONE_CALENDAR_MODAL,
  HIDE_CREATE_BOOKING_MODAL,
  HIDE_CREATE_BOOKING_WARNING_MODAL,
  HIDE_DELETE_CALENDAR_MODAL,
  HIDE_DELETE_SUB_CALENDAR_MODAL,
  OPEN_CLONE_CALENDAR_MODAL,
  OPEN_CREATE_BOOKING_MODAL,
  OPEN_CREATE_BOOKING_WARNING_MODAL,
  OPEN_DELETE_CALENDAR_MODAL,
  OPEN_DELETE_SUB_CALENDAR_MODAL,
  RESET_SELECTED_CALENDAR,
  RESET_SUB_CALENDAR,
  UPDATE_BOOKING_CALENDAR,
  UPDATE_BOOKING_CALENDAR_FAILED,
  UPDATE_BOOKING_CALENDAR_SUCCESS,
  UPDATE_SUB_CALENDAR,
  UPDATE_SUB_CALENDAR_FAILED,
  UPDATE_SUB_CALENDAR_STATUS,
  UPDATE_SUB_CALENDAR_STATUS_FAILED,
  UPDATE_SUB_CALENDAR_STATUS_SUCCESS,
  UPDATE_SUB_CALENDAR_SUCCESS,
  SET_BOOKING_CHECKOUT_SESSION,
  GET_SELECTED_BOOKING,
  GET_SELECTED_BOOKING_FAILED,
  GET_SELECTED_BOOKING_SUCCESS,
  RESET_SELECTED_BOOKING,
  CLONE_SUB_CALENDAR,
  CLONE_SUB_CALENDAR_FAILED,
  CLONE_SUB_CALENDAR_SUCCESS,
  REORDER_CALENDARS_SUCCESS,
  REORDER_SUB_CALENDARS_SUCCESS,
  GET_OUTLOOK_CALENDARS_SUCCESS,
  SYNC_OUTLOOK_CALENDARS,
  SYNC_OUTLOOK_CALENDARS_FAILED,
  SYNC_OUTLOOK_CALENDARS_SUCCESS,
  GET_SUB_CALENDAR_REPORTS,
  GET_SUB_CALENDAR_REPORTS_FAILED,
  GET_SUB_CALENDAR_REPORTS_SUCCESS,
  GET_BOOKING_DATE_REPORTS,
  GET_BOOKING_DATE_REPORTS_FAILED,
  GET_BOOKING_DATE_REPORTS_SUCCESS,
  RESET_BOOKING_DATE_REPORTS,
  GET_CALENDAR_GROUP_REPORTS,
  GET_CALENDAR_GROUP_REPORTS_FAILED,
  GET_CALENDAR_GROUP_REPORTS_SUCCESS,
  GET_BOOKING_STATUS_REPORTS_FAILED,
  GET_BOOKING_STATUS_REPORTS,
  GET_BOOKING_STATUS_REPORTS_SUCCESS,
  GET_USER_BOOKING_REPORTS,
  GET_USER_BOOKING_REPORTS_FAILED,
  GET_USER_BOOKING_REPORTS_SUCCESS,
  GET_BOOKING_REPORTS,
  GET_BOOKING_REPORTS_FAILED,
  GET_BOOKING_REPORTS_SUCCESS,
  RESET_BOOKING_FEATURE,
} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",
  calendars: [],
  bookings: [],
  subCalendars: [],
  bookingsAreLoading: false,
  selectedCalendar: null,
  selectedSubCalendar: null,
  allCalendars: [],
  createBookingModalIsOpen: false,
  createBookingWarningModalIsOpen: false,
  allSubCalendars: [],
  createBookingLoading: false,
  cloneCalendarModalIsOpen: false,
  deleteCalendarModalIsOpen: false,
  calendarCanBeDeleted: false,
  deleteSubCalendarModalIsOpen: false,
  bookingCheckoutSession: null,
  selectedBooking: null,
  outlookCalendars: null,
  subCalendarReports: null,
  bookingDateReports: null,
  calendarGroupReports: null,
  bookingStatusReports: null,
  userBookingReports: null,
  bookingReports: null,
}

const BookingsFeature = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BOOKING_CALENDARS:
    case GET_SUB_CALENDARS:
    case UPDATE_SUB_CALENDAR_STATUS:
    case CREATE_BOOKING_CALENDAR:
    case UPDATE_BOOKING_CALENDAR:
    case GET_SUB_CALENDAR:
    case GET_ALL_CALENDARS:
    case GET_ALL_SUB_CALENDARS:
    case CREATE_SUB_CALENDAR:
    case CLONE_CALENDAR:
    case DELETE_CALENDAR:
    case CHECK_CALENDAR_CAN_BE_DELETED:
    case GET_CALENDAR:
    case DELETE_SUB_CALENDAR:
    case UPDATE_SUB_CALENDAR:
    case GET_SELECTED_BOOKING:
    case CLONE_SUB_CALENDAR:
    case SYNC_OUTLOOK_CALENDARS:
    case GET_SUB_CALENDAR_REPORTS:
    case GET_BOOKING_DATE_REPORTS:
    case GET_CALENDAR_GROUP_REPORTS:
    case GET_USER_BOOKING_REPORTS:
    case GET_BOOKING_REPORTS:
      return {
        ...state,
        loading: true,
      }
    case GET_BOOKINGS:
      return {
        ...state,
        bookingsAreLoading: true,
      }
    case GET_BOOKING_CALENDARS_SUCCESS:
      return {
        ...state,
        calendars: action.payload,
        loading: false,
      }
    case GET_BOOKING_CALENDARS_FAILED:
    case GET_SUB_CALENDARS_FAILED:
    case UPDATE_SUB_CALENDAR_STATUS_FAILED:
    case CREATE_BOOKING_CALENDAR_FAILED:
    case UPDATE_BOOKING_CALENDAR_FAILED:
    case GET_SUB_CALENDAR_FAILED:
    case GET_ALL_CALENDARS_FAILED:
    case GET_ALL_SUB_CALENDARS_FAILED:
    case CREATE_SUB_CALENDAR_FAILED:
    case CLONE_CALENDAR_FAILED:
    case DELETE_CALENDAR_FAILED:
    case CHECK_CALENDAR_CAN_BE_DELETED_FAILED:
    case GET_CALENDAR_FAILED:
    case DELETE_SUB_CALENDAR_FAILED:
    case UPDATE_SUB_CALENDAR_FAILED:
    case GET_SELECTED_BOOKING_FAILED:
    case CLONE_SUB_CALENDAR_FAILED:
    case SYNC_OUTLOOK_CALENDARS_FAILED:
    case GET_SUB_CALENDAR_REPORTS_FAILED:
    case GET_BOOKING_DATE_REPORTS_FAILED:
    case GET_CALENDAR_GROUP_REPORTS_FAILED:
    case GET_BOOKING_STATUS_REPORTS_FAILED:
    case GET_USER_BOOKING_REPORTS_FAILED:
    case GET_BOOKING_REPORTS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_BOOKINGS_FAILED:
      return {
        ...state,
        error: action.payload,
        bookingsAreLoading: false,
      }
    case GET_BOOKINGS_SUCCESS:
      return {
        ...state,
        bookings: action.payload,
        bookingsAreLoading: false,
      }
    case GET_SUB_CALENDARS_SUCCESS:
      return {
        ...state,
        subCalendars: action.payload,
        loading: false,
      }
    case UPDATE_SUB_CALENDAR_STATUS_SUCCESS:
      return {
        ...state,
        allSubCalendars: state.allSubCalendars?.map(item =>
          item?.id === action.payload?.id
            ? { ...action.payload, status: action?.payload?.status ? 1 : 0 }
            : item
        ),
        loading: false,
      }
    case CREATE_BOOKING_CALENDAR_SUCCESS:
      return {
        ...state,
        selectedCalendar: action.payload,
        allCalendars: [...state.allCalendars, action.payload],
        loading: false,
      }
    case UPDATE_BOOKING_CALENDAR_SUCCESS:
    case GET_CALENDAR_SUCCESS:
      return {
        ...state,
        selectedCalendar: action.payload,
        loading: false,
      }
    case RESET_SELECTED_CALENDAR:
      return {
        ...state,
        selectedCalendar: null,
        outlookCalendars: null,
      }
    case GET_SUB_CALENDAR_SUCCESS:
    case UPDATE_SUB_CALENDAR_SUCCESS:
      return {
        ...state,
        selectedSubCalendar: action.payload,
        loading: false,
      }
    case CREATE_SUB_CALENDAR_SUCCESS:
      return {
        ...state,
        selectedSubCalendar: action.payload,
        allSubCalendars: [...state.allSubCalendars, action.payload],
        loading: false,
      }
    case RESET_SUB_CALENDAR:
      return {
        ...state,
        selectedSubCalendar: null,
      }
    case GET_ALL_CALENDARS_SUCCESS:
      return {
        ...state,
        allCalendars: action.payload,
        loading: false,
      }
    case OPEN_CREATE_BOOKING_MODAL:
      return {
        ...state,
        createBookingModalIsOpen: true,
      }
    case HIDE_CREATE_BOOKING_MODAL:
      return {
        ...state,
        createBookingModalIsOpen: false,
      }
    case OPEN_CREATE_BOOKING_WARNING_MODAL:
      return {
        ...state,
        createBookingWarningModalIsOpen: true,
      }
    case HIDE_CREATE_BOOKING_WARNING_MODAL:
      return {
        ...state,
        createBookingWarningModalIsOpen: false,
      }
    case GET_ALL_SUB_CALENDARS_SUCCESS:
      return {
        ...state,
        allSubCalendars: action.payload,
        loading: false,
      }
    case CREATE_BOOKING:
      return {
        ...state,
        createBookingLoading: true,
      }
    case CREATE_BOOKING_FAILED:
      return {
        ...state,
        error: action.payload,
        createBookingLoading: false,
      }
    case CREATE_BOOKING_SUCCESS:
      return {
        ...state,
        createBookingLoading: false,
      }
    case OPEN_CLONE_CALENDAR_MODAL:
      return {
        ...state,
        cloneCalendarModalIsOpen: true,
      }
    case HIDE_CLONE_CALENDAR_MODAL:
      return {
        ...state,
        cloneCalendarModalIsOpen: false,
      }
    case CLONE_CALENDAR_SUCCESS:
    case DELETE_CALENDAR_SUCCESS:
    case DELETE_SUB_CALENDAR_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case OPEN_DELETE_CALENDAR_MODAL:
      return {
        ...state,
        deleteCalendarModalIsOpen: true,
      }
    case HIDE_DELETE_CALENDAR_MODAL:
      return {
        ...state,
        deleteCalendarModalIsOpen: false,
      }
    case CHECK_CALENDAR_CAN_BE_DELETED_SUCCESS:
      return {
        ...state,
        loading: false,
        calendarCanBeDeleted: action.payload,
      }
    case OPEN_DELETE_SUB_CALENDAR_MODAL:
      return {
        ...state,
        deleteSubCalendarModalIsOpen: true,
      }
    case HIDE_DELETE_SUB_CALENDAR_MODAL:
      return {
        ...state,
        deleteSubCalendarModalIsOpen: false,
      }
    case SET_BOOKING_CHECKOUT_SESSION:
      return {
        ...state,
        bookingCheckoutSession: action.payload,
      }
    case GET_SELECTED_BOOKING_SUCCESS:
      return {
        ...state,
        selectedBooking: action.payload,
        loading: false,
      }
    case RESET_SELECTED_BOOKING:
      return {
        ...state,
        selectedBooking: null,
      }
    case CLONE_SUB_CALENDAR_SUCCESS:
      return {
        ...state,
        allSubCalendars: [...state.allSubCalendars, action.payload],
        loading: false,
      }
    case REORDER_CALENDARS_SUCCESS:
      return {
        ...state,
        allCalendars: state.allCalendars?.map(calendar => {
          let newVal = action.payload?.find(x => x.id === calendar.id)
          return { ...calendar, order: newVal?.order }
        }),
      }
    case REORDER_SUB_CALENDARS_SUCCESS:
      return {
        ...state,
        allSubCalendars: state.allSubCalendars?.map(calendar => {
          let newVal = action.payload?.find(x => x.id === calendar.id)
          return !newVal ? calendar : { ...calendar, order: newVal?.order }
        }),
      }
    case GET_OUTLOOK_CALENDARS_SUCCESS:
      return {
        ...state,
        outlookCalendars: action.payload,
      }
    case SYNC_OUTLOOK_CALENDARS_SUCCESS:
      return {
        ...state,
        selectedCalendar: {
          ...state.selectedCalendar,
          outlook_sync_calendars_conflicts:
            action?.payload?.outlook_sync_calendars_conflicts,
          outlook_sync_calendars_add:
            action?.payload?.outlook_sync_calendars_add,
        },
        loading: false,
      }
    case GET_SUB_CALENDAR_REPORTS_SUCCESS:
      return {
        ...state,
        subCalendarReports: action.payload,
        loading: false,
      }
    case GET_BOOKING_DATE_REPORTS_SUCCESS:
      return {
        ...state,
        bookingDateReports: action.payload,
        loading: false,
      }
    case RESET_BOOKING_DATE_REPORTS:
      return {
        ...state,
        bookingDateReports: null,
      }
    case GET_CALENDAR_GROUP_REPORTS_SUCCESS:
      return {
        ...state,
        calendarGroupReports: action.payload,
        loading: false,
      }
    case GET_BOOKING_STATUS_REPORTS:
      return {
        ...state,
        bookingStatusReports: null,
        loading: true,
      }
    case GET_BOOKING_STATUS_REPORTS_SUCCESS:
      return {
        ...state,
        bookingStatusReports: action.payload,
        loading: false,
      }
    case GET_USER_BOOKING_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        userBookingReports: action.payload,
      }
    case GET_BOOKING_REPORTS_SUCCESS:
      return {
        ...state,
        bookingReports: action.payload,
        loading: false,
      }
    case RESET_BOOKING_FEATURE:
      return {
        ...state,
        calendars: [],
        bookings: [],
        subCalendars: [],
        allCalendars: [],
        allSubCalendars: [],
      }
    default:
      return state
  }
}

export default BookingsFeature
